import { updateStatusService } from '../../../services/updateStatusService';
import { Popup, ButtonV3, CardV1 } from 'gf-ui-components-mui-lib';
import { useFileUploadContext } from '../../../context/fileUploadContext';
import { useTableContext } from '../../../context/tableContext';
import { Grid, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const UpdateStatus = () => {
  const { setFailedWindow, setSuccessWindow, successWindow, failedWindow } =
    useFileUploadContext();
  const {
    setSelectedRows,
    selectedStatus,
    setSelectedStatus,
    setUpdateStatusWindow,
    selectedRows,
    statusList,
    setSelectedRowsWithPage,
    selectedRowsWithPage,
    updateStatus,
    setUpdateStatus,
  } = useTableContext();
  const statusUpdates = () => {
    updateStatusService(
      selectedStatus,
      selectedRows,
      setUpdateStatusWindow,
      setSuccessWindow,
      setFailedWindow,
      successWindow,
      failedWindow,
      setSelectedRows,
      setSelectedStatus,
      setSelectedRowsWithPage,
      selectedRowsWithPage,
      setUpdateStatus,
      updateStatus
    );
  };

  return (
    <Popup
      id='filters'
      isOpen={true}
      sx={{
        borderRadius: '12px !important',
        width: '30%',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'white',
        border: '0px !important',
        boxSizing: 'none',
        boxShadow:
          '0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          width: '8px',
          borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#EAECF0',
          borderRadius: '8px',
          width: '8px',
        },
      }}
    >
      <CardV1
        sx={{
          padding: '16px 24px 0px 24px',
          borderRadius: '0 !important',
          '@media (max-width: 1440px)': {
            padding: '16px 16px 0px 16px',
          },
        }}
        bottomPadding={true}
        rightPadding={false}
        header={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Grid
              sx={{
                '@media (max-width: 1440px)': {
                  fontSize: '12px',
                },
              }}
              className='popup-title'
            >
              Update status of selected chargers
            </Grid>
            <IconButton>
              <CloseIcon
                sx={{
                  '@media (max-width: 1440px)': {
                    fontSize: '18px',
                  },
                }}
                className='close-icon'
                onClick={() => {
                  setUpdateStatusWindow(false);
                }}
              />
            </IconButton>
          </div>
        }
        children={
          <div style={{ height: 'calc(100vh - 400px)', overflow: 'auto' }} className='status-list'>
            {statusList?.map((item: any) => {
              return (
                <li
                  key={item?.name}
                  style={{
                    listStyleType: 'none',
                    gap: '8px',
                    display: 'flex',
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    paddingLeft: '10px',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    background:
                      selectedStatus === item?.name
                        ? 'var(--gray-50, #F9FAFB)'
                        : 'none',
                  }}
                  onClick={() => setSelectedStatus(item?.name)}
                >
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <img
                      src={item?.imageIcon ?? ''}
                      alt=''
                      style={{
                        width: '24px',
                        height: '24px',
                        marginRight: '12px',
                        position: 'relative',
                        top: '1px',
                      }}
                    />
                    <Grid
                      sx={{
                        color: 'var(--gray-900, #242424)',
                        fontFamily: 'Poppins',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: '24px',
                        position: 'relative',
                        top: '1px',
                        '@media (max-width: 1440px)': {
                          fontSize: '12px',
                        },
                      }}
                    >
                      {item?.name}
                    </Grid>
                  </span>

                  {selectedStatus === item?.name && (
                    <img
                      src={item?.tickIcon}
                      alt=''
                      style={{ marginRight: '16px' }}
                    />
                  )}
                </li>
              );
            })}
          </div>
        }
        footer={
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1,
              width: '100%',
              paddingTop: '8px',
              paddingBottom: '16px',
              gap: '12px',
            }}
          >
            <ButtonV3
              variant='outlined'
              sx={{
                flex: 1,
                boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
                '&:hover': {
                  backgroundColor: 'rgba(25, 118, 210, 0.04)',
                  border: '1px solid #D0D5DD',
                },
                '@media (max-width: 1440px)': {
                  height: '35px',
                },
              }}
              onClick={() => setUpdateStatusWindow(false)}
              id="cancel-btn"
            >
              Cancel
            </ButtonV3>
            <ButtonV3
              variant='contained'
              sx={{
                flex: 1,
                background: '#3d3ad3',
                color: '#FFFFFF',
                ':hover': {
                  background: '#3d3ad3',
                },
                '@media (max-width: 1440px)': {
                  height: '35px',
                },
              }}
              onClick={statusUpdates}
              id="apply-changes-btn"
            >
              Apply Changes
            </ButtonV3>
          </div>
        }
      />
      <CardV1
        sx={{
          fontFamily: 'Poppins',
          fontSize: '12px',
          fontWeight: 500,
          lineHeight: '24px',
          background: '#FFBE4D',
          color: '#051433',
          padding: '0px 24px',
          paddingBottom: '10px',
        }}
        footer={
          'Please make sure you have correctly selected the charger(s) you wish to update before proceeding'
        }
      />
    </Popup>
  );
};
